import { Stack, Heading, Text } from "@chakra-ui/react";
import React from "react";

const OpportunityBox = ({ title, description }) => {
  return (
    <Stack
      alignItems="start"
      py={10}
      px={5}
      borderRadius="50px 0px 50px 0px"
      gap={2}
      bg={"#91D2F6BF"}
      height="full"
    >
      <Heading color="brand.800" fontSize="25px" fontWeight={"semibold"}>
        {title}
      </Heading>
      <Text color="brand.800">{description}</Text>
    </Stack>
  );
};
export default OpportunityBox;
